import { render } from "./GDPRView.vue?vue&type=template&id=3e21b4e0"
import script from "./GDPRView.vue?vue&type=script&lang=js"
export * from "./GDPRView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__